import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  TextField,
  alpha,
  inputClasses,
  inputLabelClasses,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";

export default function PasswordInput({ field, ...props }) {
  const theme = useTheme();
  const [showPassword, setShowPassword] = useState(false);
  console.log("entro en passss");
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <FormControl fullWidth variant="standard"
    sx={{
    paddingTop: 1
    }}
    >
      <InputLabel
        {...{
          sx: {
            // set the color of the label when not shrinked
            color: "gray",
            padding: "18px 15px",
            fontSize: 16,
            [`&.${inputLabelClasses.shrink}`]: {
              // set the color of the label when shrinked (usually when the TextField is focused)
              padding: "0px 24px",
            },
          },
        }}
      >
        {props.label}
      </InputLabel>
      <Input
        // {...props}
        key={props.key}
        id={props.id}
        {...{
          disableUnderline: true,
          placeholder: field.label,
          type: showPassword ? "text" : "password",
          //   style: {
          //     padding: "6px 10px",
          //     backgroundColor: "rgba(200,200,200,0.1)",
          //     borderRadius: 10,
          //   },
          sx: {
            color: "gray",
            padding: "24px 18px",
            fontSize: 16,
            [`&.${inputLabelClasses.shrink}`]: {
              padding: "12px 24px",
              lineHeight: 1,
            },
          },
        }}
        type={showPassword ? "text" : "password"}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        sx={{
          padding: "10px 18px",
          backgroundColor: alpha(theme.palette.primary.light, 0.05),
          boxShadow: "0px 0px 2px gray",
          borderRadius: "30px",
          fontSize: 16,
          [`&.${inputClasses.focused}`]: {
            boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
          },
        }}
      />
    </FormControl>
  );
  /*
        return (<TextField
            InputLabelProps={{
                sx: {
                    // set the color of the label when not shrinked
                    color: "gray",
                    padding: '5px 10px',
                    [`&.${inputLabelClasses.shrink}`]: {
                        // set the color of the label when shrinked (usually when the TextField is focused)
                        padding: '0px 14px',
                    }
                }
            }}
            InputProps={{ disableUnderline: true, placeholder: field.label, style: { padding: '8px 10px', backgroundColor: 'rgba(200,200,200,0.3)', borderRadius: 10 } }}
    
            inputProps={{ inputMode: field.numeric ? 'numeric' : 'text', pattern: '[0-9]*' }}
            {...props}
            // type={showPassword ? 'text' : 'password'}
            type="password"
            inputProps={{ placeholder: 'hola', type: 'password' }}
        />)
        */
}
